import React, { useEffect, useState } from "react";

export const MesSelect = ({ name, value, onChange, anioInicio, mesInicio }) => {
  const [state, setState] = useState([]);

  const nombresMeses = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", 
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
  ];

  useEffect(() => {
    if (anioInicio && mesInicio) {
      const meses = generarMeses(anioInicio, mesInicio);
      setState(meses);
    }
  }, [anioInicio, mesInicio]);

  const generarMeses = (anio, mes) => {
    const meses = [];
    let anioActual = anio;
    let mesActual = mes;

    for (let i = 0; i < 12; i++) {
      const mesFormateado = mesActual < 10 ? `0${mesActual}` : mesActual;
      const nombreMes = nombresMeses[mesActual - 1];

      meses.push({
        value: `${anioActual}-${mesFormateado}`, 
        linea: `${anioActual} - ${nombreMes}`,
      });

      mesActual++;
      if (mesActual > 12) {
        mesActual = 1;
        anioActual++;
      }
    }
    return meses;
  };


  return (
    <select
      className="select-categoria"
      name={name}
      value={value}
      onChange={onChange}
    >
      {state.map((item) => (
        <option key={`linea-${item.value}`} value={item.value}>
          {item.linea}
        </option>
      ))}
    </select>
  );
};
